import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PricingSection } from '../components/PricingSection';
import { AboutCourse } from '../components/AboutCourse';
import { CourseDetails } from '../components/CourseDetails';
import { LearningOutcomes } from '../components/LearningOutcomes';
import { CareerOutcomes } from '../components/CareerOutcomes';
import { Testimonials } from '../components/Testimonials';
import { InstructorHighlight } from '../components/InstructorHighlight';
import { FloatingCTA } from '../components/FloatingCTA';
export function CourseDetailPage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-726">
      <main className="flex-grow pt-20" data-id="element-727">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 py-8" data-id="element-728">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-729">
            <div className="lg:col-span-2" data-id="element-730">
              <HeroSection data-id="element-731" />
              <AboutCourse data-id="element-732" />
              <LearningOutcomes data-id="element-733" />
              <CareerOutcomes data-id="element-734" />
              <CourseDetails data-id="element-735" />
              <InstructorHighlight data-id="element-736" />
              <Testimonials data-id="element-737" />
            </div>
            <div className="lg:col-span-1" data-id="element-738">
              <div className="lg:sticky lg:top-24" data-id="element-739">
                <PricingSection data-id="element-740" />
              </div>
            </div>
          </div>
        </div>
      </main>
      <FloatingCTA data-id="element-741" />
    </div>;
}